<template>
	<div>
		<div class="title">保障计划及人员
			<span class="subtitle">支持选择多个职业类别</span>
		</div>
		<Form :model="form" :label-width="125" ref="form" class="mt15">
			<FormItem 
			label="保障期限：" class="w600" prop="insurancePeriod"
			:rules="{required:true,message:'请选择保障期限',trigger:'change'}">
				<Select 
					v-model="form.insurancePeriod" 
					placeholder="请选择保障期限" 
					style="width:100%"
					@on-change="dateChange('insurancePeriod')">
					<Option value="1">1个月</Option>
					<Option value="3">3个月</Option>
				</Select>
			</FormItem>
			<FormItem label="保障起期：" class="w600" prop="effectiveDateStart" required>
				<DatePicker v-model="form.effectiveDateStart" type="date" placeholder="请选择保障起期" style="width: 100%" disabled @on-change="dateChange('effectiveDateStart')" :options="dateOptions">
				</DatePicker>
				<!-- <span class="errorMsg">(T+1)</span> -->
			</FormItem>
			<FormItem label="保障止期：" class="w600" required>
				{{ form.effectiveDateEnd }}
			</FormItem>
		</Form>
		<!-- <p v-if="fiveRisk" class="errorMsg">5类人员占比超过50%，保费上浮20%，上浮保费已标红色。</p> -->
		<Table :columns="columns" :data="list" highlight-row disabled-hover>
			<template slot-scope="{ row, index }" slot="jobTypeCode">
				<div>
					<div style="display: flex;">
					<SelectJob :list="jobList" :value="list[index].jobTypeCode" :disabled="disabledUrl" productCode="CCIC_EMPLOYER_LIABILITY" @change="val=>jobChange(val,index)"/>
					</div>
					<p class="mt10">风险分类：{{riskCategoryShow(list[index].riskCategory)}}</p>
				</div>
			</template>
			<template slot-scope="{ row, index }" slot="scheme">
				<div class="caseContainer">
					<Select v-model="list[index].scheme" :disabled="disabledUrl" placeholder="请选择保障方案" @on-change="caseChange(list[index])" transfer>
						<Option :value="item.key" v-for="(item, index) in caseList" :key="index">{{ item.value }}</Option>
					</Select>
					<p class="mt10">
						保费：{{list[index].premiumPer?(list[index].premiumPer+' 元/人'):'/' }}
					</p>
				</div>
			</template>
			<template slot-scope="{ row, index }" slot="quantity">
				<Input v-model="list[index].quantity" :maxlength="5" style="width:50px" :disabled="disabledUrl"
					@on-blur="countChange(list[index])"></Input> 人
			</template>
			<template slot-scope="{ row, index }" slot="premium">
				<span :style="{ color: list[index].fiveRisk ? 'red' : '#333' }">{{ list[index].premium || 0 }}元</span>
			</template>
			<template slot-scope="{ row, index }" slot="adjustPremium">
				<span>每人</span>
				<Input v-model="list[index].adjustPremium" :maxlength="5" :disabled="disabledUrl" style="width:50px" @change.native="premiumChange(list[index])"></Input>
			</template>
			<template slot-scope="{ row, index }" slot="manage">
				<a @click="del(index)" v-if="!disabledUrl">删除</a>
			</template>
		</Table>
		<Table :columns="totalColumns" :data="totalData" :show-header="false" v-if="list.length > 0" disabled-hover>
			<template slot-scope="{ row, index }" slot="count">
				{{ row.count }}人
			</template>
			<template slot-scope="{ row, index }" slot="totalAmount">
				{{ row.totalAmount }}元
			</template>
		</Table>
		<p class="errorMsg" v-if="errorMsg">{{ errorMsg }}</p>
		<div class="download-btn mt15">
			<Button :disabled="list.length>=5" @click="add">继续添加职业类别</Button>
			<UploadFile style="display:inline-block" url="/pc/broker/import/importEmployee" :show-upload-list="false"
				:data="uploadParams" btn-text="上传人员明细" @on-success="uploadSuccess" :disabled="!canDownload" />
			<span class="downloadFile" v-if="canDownload">
				已根据选择的职业、方案及人数自动生成模板，请点击
				<a @click="download">下载</a>
			</span>
			<Button :type="personListValidate ? 'success' : 'error'" @click="openPersonList"
				v-show="personList.length > 0">已上传人员信息</Button>
			<Button type="error" @click="clearPersonList" v-show="personList.length > 0">清空人员信息</Button>
		</div>
		<Modal v-model="personListShow" :mask-closable="false" width="950" title="已上传人员信息">
			<p class="errorMsg" v-if="!personListValidate">
				上传的人员信息存在错误，请查看校验结果，关闭后重新上传正确的人员明细。
			</p>
			<el-table class="mt10" ref="table" :data="personListNewShow" style="width: 100%" :max-height="400">
				<el-table-column prop="checkMsg" label="校验结果" show-overflow-tooltip width="200">
                    <template slot-scope="{ row }">
						<span style="color:red" v-if="!row.checkResult.empty">
							{{ row.checkResult.result }}
						</span>
						<span style="color:green" v-else>
							校验通过
						</span>
					</template>
                </el-table-column>
				<el-table-column prop="jobTypeName" label="工种" show-overflow-tooltip width="180"></el-table-column>
                <el-table-column prop="riskCategory" label="风险类别" show-overflow-tooltip width="180">
                    <template slot-scope="{row}">
                        {{riskCategoryShow(row.riskCategory)}}
                    </template>
                </el-table-column>
                <el-table-column prop="schemeName" label="保障方案" show-overflow-tooltip width="180"></el-table-column>
				<el-table-column prop="companyNameFrom" label="派遣单位" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="companyNameTo" label="实际用工单位" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="insuredPersonName" label="姓名" width="100"></el-table-column>
                <el-table-column prop="idCard" label="证件号码" width="180"></el-table-column>
                <el-table-column prop="gender" label="性别" width="100"></el-table-column>
                <el-table-column prop="age" label="年龄" width="100"></el-table-column>
				<el-table-column prop="desc" label="工作描述备注" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="province" label="用工单位所在省" width="180"></el-table-column>
				<el-table-column prop="city" label="用工单位所在市" width="180"></el-table-column>
				<el-table-column prop="district" label="用工单位所在区" width="180"></el-table-column>
            </el-table>
			<Row class="mt10" v-if="personListNewShow.length>0">
                <Col :span="24" class="right">
                    <el-pagination
                        :current-page="pageinfo.page"
                        :page-size="pageinfo.size"
                        :total="pageinfo.total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                    >
                    </el-pagination>
                </Col>
            </Row>
			<template slot="footer">
				<Button type="primary" @click="personListShow = false">关闭</Button>
			</template>
		</Modal>
	</div>
</template>
<script>
import UploadFile from './common/UploadFile'
import SelectJob from './common/SelectJob'
export default {
	components: { UploadFile, SelectJob },
	props: {
		info: Object,
	},
	data() {
		return {
			id: this.$route.params.id,
			columns: [
				{ title: '工种', slot: 'jobTypeCode', minWidth: 300 },
				{ title: '保障方案', slot: 'scheme', minWidth: 280 },
				{ title: '人数', slot: 'quantity', width: 120, align: 'center' },
				{ title: '保费小计（元）', slot: 'premium', width: 140 },
				{ title: '人单价调整', slot: 'adjustPremium', width: 120 },
				{ title: '操作', slot: 'manage', width: 70 }
			],
			list: [],
			form: {
				insurancePeriod:'1'
			},
			extraInfo:{
				isSubjoinProportionAdj:1
			},
			dateOptions: {},
			caseList: [],
			totalColumns: [
				{ title: '', key: 'title', minWidth: 200, align: 'right' },
				{ title: '', slot: 'count', width: 120 },
				{ title: '', slot: 'totalAmount', width: 190 },
			],
			totalData: [{
				title: '合计',
				count: '',
				totalAmount: '',
			}],
			canDownload: false,
			errorMsg: '',
			personList: [],
			personListNewShow:[],
			personListShow: false,
			isReset: this.$route.query.reset || '', // 是否重新投保
			orderNo: this.$route.query.orderNo || '',
			jobList: [],
			pageinfo: {
				page: 1,
				size: 20,
				total: 0
			}
		}
	},
	computed: {
		/*校验人员明细*/
		disabledUrl() {
			return this.personList.length > 0 ? true : false;
		},
		/*校验人员明细*/
		personListValidate() {
			let flag = true;
			this.personList.map(item => {
				if (!(item.checkResult && item.checkResult.empty)) {
					flag = false;
				}
			})
			return this.personList.length > 0 && flag;
		},
		fiveRisk() {
			let fiveRisk = false
			this.list.forEach(item => {
				if (item.fiveRisk) fiveRisk = true
			})
			return fiveRisk
		},
		uploadParams() {
			let list = []
			this.list.forEach((item) => {
				if (item.jobTypeCode && item.scheme && item.quantity) {
					list.push({
						jobTypeCode: item.jobTypeCode,
						jobTypeName: item.jobTypeName,
						premium: item.premium,
						quantity: item.quantity,
						riskCategory: item.riskCategory,
						riskCategoryName: item.riskCategoryName,
						quoteRiskCategory:item.riskCategory,
						scheme: item.scheme,
						schemeName: item.schemeName,
						adjustPremium: item.adjustPremium
					})
				}
			})
			return {
				applicationReqDTO: JSON.stringify({
					subjectMatter: list,
					insurancePeriod: this.form.insurancePeriod,
					extraInfo: this.extraInfo,
					productCode: this.$route.query.productCode || this.info.productCode,
					effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
					effectiveDateEnd: this.formatDate(this.form.effectiveDateEnd),
					bizId: 'INDUSTRY_ENTERPRISE'
				})
			}
		}
	},
	watch: {
		info(v) {
			this.setData();
			if (v.productCode) {
				this.form.insurancePeriod = v.insurancePeriod=='12'?'1':String(v.insurancePeriod);
				this.setStartTimeOption();
				this.getCaseList();
			}
		}
	},
	async created() {
		this.setData();
		this.form.insurancePeriod = this.form.insurancePeriod=='12'?'1':String(v.insurancePeriod);
		if (!this.isReset) {
			this.setStartTimeOption();
		}
		this.getTree();
		if (this.info.productCode) {
			await this.getCaseList();  // 先等待获取方案列表
		}
		this.add()  // 再添加工种
	},
	methods: {
		 /** 切换每页显示条数 */
		 handleSizeChange(val) {
			this.pageinfo.page = 1;
			this.pageinfo.size = val;
			this.personListNewShow= this.currentChangePage(val, this.pageinfo.page);
			this.pageinfo.total = this.personList.length;
		},
		/** 切换分页 */
		handleCurrentChange(val) {
			this.pageinfo.page = val;
			this.personListNewShow = this.currentChangePage(this.pageinfo.size, val);
			this.pageinfo.total = this.personList.length;
		},
		// 分页方法
		currentChangePage(size, current) {
			const tablePush = [];
			let array = this.jsonCopy(this.personList);
			array.forEach((item, index) => {
				if (size * (current - 1) <= index && index <= size * current - 1) {
					tablePush.push(item);
				}
			});
			return tablePush;
		},
		riskCategoryShow(name){
			let str = ''
			switch(name){
				case 'RISK_1':
					str = "一类"
				break;
				case 'RISK_2':
					str = "二类"
				break;
				case 'RISK_3':
					str = "三类"
				break;
				case 'RISK_4':
					str = "四类"
				break;
				case 'RISK_5':
					str = "五类"
				break;
				case 'RISK_6':
					str = "六类"
				break;
				default:
					str = ""
				break;
			}
			return str
		},
		// 清空人员信息
		clearPersonList() {
			this.$Modal.confirm({
				title: '确定清空人员信息？',
				okText:'取消',
				cancelText:'确认',
				onOk: () => {
					
				},
				onCancel: () => {
					this.personList = [];
					this.personListNewShow = [];
					this.pageinfo = {
						page: 1,
						size: 20,
						total: 0
					}
				}
			});
		},
		getTree() {
			this.$axios.post('/broker/dict/items/tree.json', {
				bizId:'INDUSTRY_ENTERPRISE',
				companyId:'10157',
				productCode: this.$route.query.productCode || this.info.productCode,
				dictCode: 'work_type'
			}).then((res) => {
				this.jobList = this.convertTree(res)
			})
		},
		convertTree(tree) {
			let list = tree.map(item => {
				return {
					...item,
					loading: false
				}
			})
			let result = JSON.parse(JSON.stringify(list).replace(/"value"/g, '"label"').replace(/"key"/g, '"value"'))
			return result
		},
		async setStartTimeOption() {
			let startDate = await this.getEffectiveDateStartRange(this.formatDate(new Date()), 1, 'start');
			this.dateOptions = {
				disabledDate(date) {
					return date && (date.valueOf() < Date.parse(startDate + ' 00:00:00'))
				}
			}
			this.form.effectiveDateStart = startDate;
			this.dateChange();
		},
		setData() {
			this.form = this.jsonCopy(this.info);
			this.form.insurancePeriod = String(this.info.insurancePeriod)
			if(this.info.extraInfo){
				this.extraInfo = this.info.extraInfo;
			}
			if (this.info.subjectMatter) {
				this.personList = this.info.subjectMatter;
				this.pageinfo.total = this.personList.length;
                this.personListNewShow =  this.currentChangePage(this.pageinfo.size,this.pageinfo.page)
			};
			if (this.info.groupSubjectMatter) {
				this.list = this.info.groupSubjectMatter;
			}
			this.getPremium();
		},
		// 获取方案列表
		async getCaseList() {
			await this.$axios.post('/broker/dict/items/plain.json', {
				bizId: 'INDUSTRY_ENTERPRISE',
				dictCode: 'product_plan',
				productCode: this.info.productCode
			}).then(res => {
				this.caseList = res;
			});
		},
		// 草稿箱
		drafts(){
			return new Promise ((resolve,rejct)=>{
				resolve({
					employerTotalAmountVO: {
						subjectMatterQuantity: this.totalData[0].count,
						effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
						effectiveDateEnd: this.form.effectiveDateEnd,
						insurancePeriod: this.form.insurancePeriod,
						premium: this.totalData[0].totalAmount,
						extraInfo: this.extraInfo
					},
					importEmployeeVOS: this.personList,
					subjectMatter: this.list
				})
			})
		},
		// 校验
		async val() {
			let flag = await this.$refs.form.validate();
			return new Promise((resolve, reject) => {
				if (flag && this.personListValidate) {
					resolve({
						employerTotalAmountVO: {
							subjectMatterQuantity: this.totalData[0].count,
							effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
							effectiveDateEnd: this.form.effectiveDateEnd,
							insurancePeriod: this.form.insurancePeriod,
							premium: this.totalData[0].totalAmount,
							extraInfo: this.extraInfo
						},
						importEmployeeVOS: this.personList,
						subjectMatter: this.list
					})
				} else {
					this.toast('保障计划或上传人员错误', 'error');
					resolve(false)
				}
			})
		},
		/*日期变化后获取起保终保日期*/
		dateChange(type) {
			if (this.form.effectiveDateStart) {
				this.getEffectiveDateEnd(this.formatDate(this.form.effectiveDateStart), this.form.insurancePeriod).then(res => {
					this.$set(this.form, 'effectiveDateEnd', res)
					this.getPremium();
				})
			}
		},
		// 获取保障范围
		getEffectiveDateStartRange(effectiveDateStart, insurancePeriod, type = 'end') {
			return this.$axios.post('/broker/insurance/application/getEffectiveDateStartRange.json', {
				effectiveDateStart: effectiveDateStart,
				insurancePeriod: insurancePeriod,
				productCode: this.info.productCode
			}).then(res => {
				if (type == 'end') {
				} else {
					return res.effectiveStartDateStart
				}
			})
		},
		// 获取保障止期，父页面fillin也会用到
		getEffectiveDateEnd(effectiveDateStart, insurancePeriod, type = 'end') {
			return this.$axios.post('/broker/insurance/application/getEffectiveDateEnd.json', {
				effectiveDateStart: effectiveDateStart,
				insurancePeriod: insurancePeriod,
				productCode: this.info.productCode
			}).then(res => {
				if (type == 'end') {
					return res.effectiveDateEnd
				} else {
					return res.effectiveDateStart
				}
			})
		},
		/*上传成功后获取数据*/
		uploadSuccess(res) {
			this.openPersonList();
			this.$nextTick(()=>{
				this.personList = res;
                this.pageinfo.total = res.length;
                this.personListNewShow =  this.currentChangePage(this.pageinfo.size,this.pageinfo.page)
			})
		},
		charAtCode(code) {
			if (code) return (this.$route.query.productCode || this.info.productCode) + code.charAt(code.length - 1)
			else return ''
		},
		/*获取保费*/
		async getPremium() {
			let list = []
			let listIndex = []
			this.list.forEach((item, index) => {
				if (item.jobTypeCode && item.scheme && item.quantity) {
					listIndex.push(index);
					list.push({
						quantity: item.quantity,
						scheme: item.scheme,
						adjustPremium: item.adjustPremium,
						extraInfo: {
							jobTypeCode: item.jobTypeCode,
							riskCategory: item.riskCategory,
							quoteRiskCategory:item.riskCategory,
						}
					})
				}
			})
			if (list.length == 0) {
				this.totalData = [{
					title: '合计',
					count: '',
					totalAmount: '',
				}]
				this.canDownload = false;
				this.errorMsg = ''
				return
			}
			let obj = {
				subjectMatter: list,
				insurancePeriod: this.form.insurancePeriod,
				extraInfo: this.extraInfo,
				productCode: this.$route.query.productCode || this.info.productCode,
				effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
				effectiveDateEnd: this.formatDate(this.form.effectiveDateEnd),
				bizId: 'INDUSTRY_ENTERPRISE',
			}
			if (!obj.effectiveDateStart) return
			let res = await this.$axios.post('/broker/quote.json', obj)
			this.$emit('set-amount', res.premium)
			res.subjectMatter.forEach((item, index) => {
				this.list[listIndex[index]].premium = item.premium;
				this.list[listIndex[index]].premiumPer=item.premiumPer;
				this.list.splice(listIndex[index], 1, this.list[listIndex[index]]);
			})
			this.totalData = [{
				title: '合计',
				count: res.subjectMatterQuantity,
				totalAmount: res.premium,
			}]
			if(res.subjectMatterQuantity<5){
				this.canDownload=false;
				this.errorMsg='累计最低投保人数为5人，请继续添加工种'
			}else{
				this.canDownload=true;
				this.errorMsg=''
			}
		},
		// 添加工种
		add() {
			this.list.push({
				jobTypeCode: '',
				scheme: 'plan1',
				schemeName: this.caseList[0].value,
				quantity: '',
				premium: '',
				adjustPremium: 0,
				premiumPer:0
			})
		},
		// 删除工种
		del(index) {
			this.$Modal.confirm({
				title: '确定删除？',
				okText:'取消',
				cancelText:'确认',
				onOk: () => {
					
				},
				onCancel: () => {
					this.list.splice(index, 1)
					this.getPremium();
				}
			});
		},
		// 选择工种
		jobChange(val, index) {
			if (!val.value) return
			let row = this.list[index]
			row.riskCategory = val.riskCategory;
			row.riskCategoryName = val.riskCategoryName;
			row.jobTypeCode = val.value;
			row.jobTypeName = val.label;
			this.list.splice(index, 1, row)
			this.setItemPrice(row)
			if(row.scheme&&row.jobTypeCode&&row.quantity){
				this.getPremium();
			}
			this.getCaseList();
		},
		// 选择方案
		caseChange(row) {
			let newindex = this.caseList.findIndex((val) => {
				return val.key == row.scheme;
			});
			if (newindex >= 0) {
				row.schemeName = this.caseList[newindex].value
			}
			this.setItemPrice(row)
			if(row.scheme&&row.jobTypeCode&&row.quantity){
				this.getPremium();
			}
		},
		// 输入人数
		countChange(row) {
			if(row.scheme&&row.jobTypeCode&&row.quantity){
				this.getPremium();
			}
		},
		// 选择高空，非高空
		aerialChange (val,index) {
			if(val&&this.list[index].scheme&&this.list[index].jobTypeCode&&this.list[index].quantity){
				this.getPremium();
			}
		},
		premiumChange(row) {
			// if (Number(row.adjustPremium) < 0) {
			// 	this.alert('不能输入负数！')
			// 	row.adjustPremium = 0
			// 	this.getPremium();
			// 	return false
			// }
			if (Number(row.adjustPremium) == 0) {
				row.adjustPremium = 0
				this.getPremium();
				return false
			}
			if (row.scheme && row.jobTypeCode && row.quantity && row.adjustPremium) {
				this.getPremium();
			}
		},
		// 获取一行年保费
		setItemPrice(row) {
			if (row.riskCategory && row.scheme) {
			} else {
				row.premium = ''
			}
		},
		// 打开上传人员明细弹窗
		openPersonList() {
			this.personListShow = true;
		},
		// 下载模板
		download() {
			this.$axios.post('/broker/export/exportTemplate/CCIC_EMPLOYER_LIABILITY_M4.json', this.list).then(res => {
				if (res) {
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '人员信息表')
					})
				}
			})
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
					if (xhr.status === 200) {
						resolve(xhr.response)
					}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		}
	}
}
</script>
<style scoped lang="less">
.download-info {
	font-size: 16px;

	span {
		color: #FF9900;
		margin-left: 20px;
	}
}

.recognize {
	&-title {
		font-weight: bold;
	}

	&-total {
		font-size: 16px;
	}
}

.caseContainer {
	padding: 10px 0;
}

.subtitle {
	color: #FF9900;
	font-size: 16px;
	margin-left: 20px;
}

.downloadFile {
	margin-left: 20px;
	margin-right: 20px;
}

.errorMsg {
	font-size: 16px;
	color: red;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/RecognizeCcic_M4.vue